import styled from 'styled-components';
import {Row, RowW50Styles, Column} from '../../common/Layouts/Layouts';

export const DetailCardLoaderWrapDiv = styled.div(
  props => `

  display:flex;
  flex-wrap: wrap;
  flex-direction: row;
  max-width: 120rem;
  margin: 0 auto;
  width:100%;
  background-color: ${props.theme.colors.white.base};
  height: 58.5rem;
  padding: ${props.theme.spacing.large.l20};

`,
);

export const DetailCardLoaderGalleryBlock = styled.div(
  props => `

  display:flex;
  flex-wrap: wrap;
  flex-direction: row;
  width:73%;
  padding-right: ${props.theme.spacing.large.l11};
`,
);

export const GalleryLoadWrap = styled.div(
  props => `
    width:100%;
    display: flex;
    flex-direction: row;
  `
);

export const HotelAboutLoader = styled.div(
  props => `
    width:100%;
    display: flex;
    flex-direction: column;
    margin-top: ${props.theme.spacing.large.l20};
  `
)

export const DetailCardLoaderPricingBlock = styled.div(
  props => `

  display:flex;
  flex-wrap: wrap;
  flex-direction: row;
  width:27%;
  border-left: 1px dashed ${props.theme.colors.grey.lightdd};
  padding-left: ${props.theme.spacing.large.l11};
`,
);

export const HotelGalleryBlockDiv = styled.div(
  props => `

  display:flex;
  flex-wrap: wrap;
  margin-right:${props.theme.spacing.base};
  background-image: linear-gradient(to left, #f4f4f4, #ececec);
  border-radius:${props.theme.misc.borderRadius.base};
  width:50.5rem;
  height:35rem;
`,
);

export const TravellerGalleryBlockDiv = styled.div(
  props => `

  display:flex;
  flex-wrap: wrap;
  flex-direction:column;
`,
);

export const TravellerGalleryInnerTopDiv = styled.div(
  props => `

  display:flex;
  flex-wrap: wrap;
  margin-bottom:${props.theme.spacing.base};
  background-image: linear-gradient(to left, #f4f4f4, #ececec);
  border-radius:${props.theme.misc.borderRadius.base};
  width:32rem;
  height:19rem;
`,
);

export const TravellerGalleryInnerBottomDiv = styled.div(
  props => `

  display:flex;
  flex-wrap: wrap;
  background-image: linear-gradient(to left, #f4f4f4, #ececec);
  border-radius:${props.theme.misc.borderRadius.base};
  width:32rem;
  height:15rem;
`,
);

export const ReviewRightComponentInnerWrapDiv = styled.div(
  props => `

  display:flex;
  flex-wrap: wrap;
  flex-direction: column;
  border: ${props.theme.misc.border.base} solid ${props.theme.colors.grey.lineGrey};
  border-radius:${props.theme.misc.borderRadius.large};

`,
);

export const GuestLikeHeaderWrapDiv = styled.div(
  props => `

  width:100%;
  display:flex;
  flex-wrap: wrap;
  padding:${props.theme.spacing.small.s5};
  border-bottom: ${props.theme.misc.border.base} solid ${props.theme.colors.grey.lineGrey};


`,
);

export const GuestLikeLoaderDiv = styled.div(
  props => `

  display:flex;
  flex-wrap: wrap;
  background-image: linear-gradient(to left, #f4f4f4, #ececec);
  border-radius:${props.theme.misc.borderRadius.small};
  width:17rem;
  height:2.1rem;


`,
);

export const AmmenitiesTypeNewDiv = styled.div(
  props => `

  display:flex;
  flex-wrap: wrap;
  background-image: linear-gradient(to left, #f4f4f4, #ececec);
  border-radius:${props.theme.misc.borderRadius.small};
  width:16rem;
  height:1.7rem;
  margin-bottom:${props.theme.spacing.small.s5};


`,
);

export const AmmenitiesTypeOuterDiv = styled.div(
  props => `

  display:flex;
  flex-wrap: wrap;
  flex-direction: column;
  padding:${props.theme.spacing.base};

`,
);

export const RightBlockAmenitiesDiv = styled.div(
  props => `

  display:flex;
  background-image: linear-gradient(to left, #f4f4f4, #ececec);
  border-radius:${props.theme.misc.borderRadius.small};
  width:22.3rem;
  height:2.3rem;

`,
);

export const RightBlockSecondDiv = styled.div(
  props => `

    display:flex;
    flex-wrap: wrap;
    flex-direction: column;
    border: ${props.theme.misc.border.base} solid ${props.theme.colors.grey.lineGrey};
    border-radius:${props.theme.misc.borderRadius.large};
    width:50%;
  `,
);

export const GuestLikeOuterWrapDiv = styled.div(
  props => `

  display:flex;
  flex-wrap: wrap;
  flex-direction: column;
  width:100%;
`,
);

export const GuestLikeInnerWrapDiv = styled.div(
  props => `

    display:flex;
    flex-wrap: wrap;
    flex-direction: column;
    width:100%;
    border: ${props.theme.misc.border.base} solid ${props.theme.colors.grey.lineGrey};
    border-radius:${props.theme.misc.borderRadius.large};

  `,
);

export const GuestLikeHeadLoadWrap = styled.div(
  props => `
    display:flex;
    flex-wrap: wrap;
    flex-direction: row;
    border-bottom: ${props.theme.misc.border.base} solid ${props.theme.colors.grey.lineGrey};
  `
)

export const GuestLikeHeaderLoaderWrapDiv = styled.div(
  props => `

    display:flex;
    flex-wrap: wrap;
    flex-direction: row;
    padding-top:${props.theme.spacing.base};
    padding-bottom:${props.theme.spacing.base};
    padding-left:${props.theme.spacing.large.l15};
    padding-right:${props.theme.spacing.large.l15};
    border-bottom: ${props.theme.misc.border.base} solid ${props.theme.colors.grey.lineGrey};

  `,
);

export const LeftSideInfoLoader = styled.div(
  props => `
    width:50%;
    display: flex;
    flex-direction: column;
  `
);

export const RightSideInfoLoader = styled.div(
  props => `
    width:50%;
    display: flex;
    flex-direction: column;
    align-items: flex-end;
  `
);

export const SpacingTopDiv = styled.div(
  props => `
    margin-top: ${props.theme.spacing.large.l20};
  `
);

export const SpacingMediumTopDiv = styled.div(
  props => `
    margin-top: ${props.theme.spacing.base};
  `
);

export const SpacingLargeTopDiv = styled.div(
  props => `
    margin-top: ${props.theme.spacing.large.l30};
  `
)



export const GuestLikeHeaderLoaderSpan = styled.span(
  props => `

    display:flex;
    flex-wrap: wrap;
    flex-direction: column;
    background-image: linear-gradient(to left, #f4f4f4, #ececec);
    border-radius:${props.theme.misc.borderRadius.small};
    width:100%;
    height:4rem;

    `,
);

export const LineSmallLoadHalfDiv = styled.div(
  props => `
    display:flex;
    flex-wrap: wrap;
    flex-direction: column;
    background-image: linear-gradient(to left, #f4f4f4, #ececec);
    border-radius:${props.theme.misc.borderRadius.small};
    width:40%;
    height:0.7rem;
    margin-bottom: ${props.theme.spacing.small.s5};
  `
);

export const LineSmallLoadQuarterDiv = styled.div(
  props => `
    display:flex;
    flex-wrap: wrap;
    flex-direction: column;
    background-image: linear-gradient(to left, #f4f4f4, #ececec);
    border-radius:${props.theme.misc.borderRadius.small};
    width:25%;
    height:0.7rem;
    margin-bottom: ${props.theme.spacing.small.s5};
  `
);

export const LineSmallLoadOneThirdDiv = styled.div(
  props => `
    display:flex;
    flex-wrap: wrap;
    flex-direction: column;
    background-image: linear-gradient(to left, #f4f4f4, #ececec);
    border-radius:${props.theme.misc.borderRadius.small};
    width:75%;
    height:0.7rem;
    margin-bottom: ${props.theme.spacing.small.s5};
  `
);

export const LineSmallLoadFullDiv = styled.div(
  props => `
    display:flex;
    flex-wrap: wrap;
    flex-direction: column;
    background-image: linear-gradient(to left, #f4f4f4, #ececec);
    border-radius:${props.theme.misc.borderRadius.small};
    width:100%;
    height:0.7rem;
    margin-bottom: ${props.theme.spacing.small.s5};
  `
);

export const ButtonLoader = styled.div(
  props => `
    width:100%;
    display: flex;
    align-items: flex-end;
    justify-content: flex-end;
    padding: ${props.theme.spacing.base};
  `
);

export const LoadButton = styled.div(
  props => `
    display:flex;
    flex-wrap: wrap;
    flex-direction: column;
    background-image: linear-gradient(to left, #f4f4f4, #ececec);
    border-radius: 3rem;
    width:40%;
    height:3.2rem;
  `
)



export const GuestLikeHeaderLoaderOneSpan = styled.span(
  props => `

    display:flex;
    flex-wrap: wrap;
    flex-direction: column;
    background-image: linear-gradient(to left, #f4f4f4, #ececec);
    border-radius:${props.theme.misc.borderRadius.small};
    margin-right:${props.theme.spacing.base};
    margin-bottom:${props.theme.spacing.large.l15};
    width:15.4rem;
    height:3.2rem;

    `,
);

export const GuestLikeHeaderLoaderTwoSpan = styled.span(
  props => `

    display:flex;
    flex-wrap: wrap;
    flex-direction: column;
    background-image: linear-gradient(to left, #f4f4f4, #ececec);
    border-radius:${props.theme.misc.borderRadius.small};
    margin-right:${props.theme.spacing.base};
    margin-bottom:${props.theme.spacing.large.l15};
    width:8.5rem;
    height:3.2rem;

      `,
);

export const SignUpOuterWrapDiv = styled.div(
  props => `

  display:flex;
  flex-wrap: wrap;
  flex-direction: column;
  width:100%;

  `,
);

export const SignUpOuterFirstWrapDiv = styled.div(
  props => `
  display:flex;
  flex-wrap: wrap;
  flex-direction: row;
  border: ${props.theme.misc.border.base} solid ${props.theme.colors.grey.lineGrey};
  border-radius:${props.theme.misc.borderRadius.large};
  padding:${props.theme.spacing.large.l15};
  justify-content: space-between;
  margin-bottom:${props.theme.spacing.large.l15}; 

  `,
);

export const SignUpOuterFirstWrapimageDiv = styled.div(
  props => `
  display:flex;
  flex-wrap: wrap;
  background-image: linear-gradient(to left, #f4f4f4, #ececec);
  border-radius:${props.theme.misc.borderRadius.small};
  width:3.6rem;
  height:3.6rem;
  `,
);

export const SignUpOuterFirstWraptextDiv = styled.div(
  props => `
  display:flex;
  flex-wrap: wrap;
  flex-direction:column;
  width:23rem;
  `,
);

export const SignUpOuterFirstWrapInnerDiv = styled.div(
  props => `
  display:flex;
  flex-wrap: wrap;
  background-image: linear-gradient(to left, #f4f4f4, #ececec);
  border-radius:${props.theme.misc.borderRadius.small};
  width:21.6rem;
  height:1.2rem;
  margin-bottom:${props.theme.spacing.small.s5};
  `,
);

export const SignUpOuterSecondWrapInnerDiv = styled.div(
  props => `
  display:flex;
  flex-wrap: wrap;
  background-image: linear-gradient(to left, #f4f4f4, #ececec);
  border-radius:${props.theme.misc.borderRadius.small};
  width:21.6rem;
  height:1.2rem;
  margin-top:${props.theme.spacing.small.s5};
  `,
);

export const SignUpOuterSecondWrapDiv = styled.div(
  props => `
  display:flex;
  flex-wrap: wrap;
  flex-direction: column;
  padding:${props.theme.spacing.large.l15};
  margin-top:${props.theme.spacing.large.l20};

  `,
);

export const GiftCardWrapDiv = styled.div(
  props => `
  display:flex;
  flex-wrap: wrap;
  background-image: linear-gradient(to left, #f4f4f4, #ececec);
  border-radius:${props.theme.misc.borderRadius.small};
  margin-top:${props.theme.spacing.large.l20};
  margin-bottom:${props.theme.spacing.base};
  width:100%;
  height:4.8rem;
  `,
);

export const HotelHeadLoad = styled.div(
  props => `
    display:flex;
    flex-wrap: wrap;
    background-image: linear-gradient(to left, #f4f4f4, #ececec);
    border-radius:${props.theme.misc.borderRadius.small};
    margin-bottom:${props.theme.spacing.large.l15};
    width:8rem;
    height:2.2rem;
  `
)

export const SignUpOuterThirdWrapDiv = styled.div(
  props => `
  display:flex;
  flex-wrap: wrap;
  flex-direction: row;
  border: ${props.theme.misc.border.base} solid ${props.theme.colors.grey.lineGrey};
  border-radius:${props.theme.misc.borderRadius.large};
  padding:${props.theme.spacing.large.l15};
  `,
);

export const PricingWrapInnerDiv = styled.div(
  props => `
  display:flex;
  flex-wrap: wrap;
  flex-direction: row;
  border: ${props.theme.misc.border.base} solid ${props.theme.colors.grey.lineGrey};
  border-radius:${props.theme.misc.borderRadius.large};
  padding:${props.theme.spacing.large.l15};
  `,
);

export const PricingTextWrapDiv = styled.div(
  props => `
  display:flex;
  flex-wrap: wrap;
  flex-direction: row;
  justify-content: space-between;
  width:100%;

  `,
);

export const PricingTextLeftWrapDiv = styled.div(
  props => `
  display:flex;
  flex-wrap: wrap;
  flex-direction:column;

  `,
);

export const PricingTextLeftOneWrapDiv = styled.div(
  props => `
  display:flex;
  flex-wrap: wrap;
  background-image: linear-gradient(to left, #f4f4f4, #ececec);
  border-radius:${props.theme.misc.borderRadius.small};
  margin-bottom:${props.theme.spacing.base};
  width:10.5rem;
  height:1.35rem;

  `,
);

export const PricingTextLeftSecondWrapDiv = styled.div(
  props => `
  display:flex;
  flex-wrap: wrap;
  background-image: linear-gradient(to left, #f4f4f4, #ececec);
  border-radius:${props.theme.misc.borderRadius.small};
  width:10.5rem;
  height:1.35rem;

  `,
);

export const PricingTextRightWrapDiv = styled.div(
  props => `
  display:flex;
  flex-wrap: wrap;
  flex-direction:column;
  padding-top:${props.theme.spacing.small.s5};

  `,
);

export const PricingTextRightTextWrapDiv = styled.div(
  props => `
  display:flex;
  flex-wrap: wrap;
  background-image: linear-gradient(to left, #f4f4f4, #ececec);
  border-radius:${props.theme.misc.borderRadius.small};
  margin-bottom:${props.theme.spacing.base};
  width:10.9rem;
  height:1.8rem;

  `,
);

export const PayAmountWrapDiv = styled.div(
  props => `
  display:flex;
  flex-wrap: wrap;
  margin-top:${props.theme.spacing.base};
  `,
);

export const PayAmountWrapInnerDiv = styled.div(
  props => `
  display:flex;
  flex-wrap: wrap;
  background-image: linear-gradient(to left, #f4f4f4, #ececec);
  border-radius:${props.theme.misc.borderRadius.small};
  width:25.5rem;
  height:4.5rem;
  
  `,
);
